import React, { useState, useEffect } from "react";
import {
  Form,
  Select,
  Button,
  Layout,
  Row,
  Col,
  Card,
  Table,
  Dropdown,
  Menu,
  Modal
} from "antd";
import { useNavigate } from "react-router-dom";
import { ServiceUtils } from "../../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../../Shared/Utils/ToasterUtils";
import BreadcrumbList from "../../../../Shared/Components/Breadcrumb/Breadcrumb";
import { useSharedState } from "../../../../Shared/Services/WindowSizeService";
import { MoreOutlined } from "@ant-design/icons";
import classNames from "classnames";
const { Option } = Select;
const { Header, Content } = Layout;

const ReportsSettings = () => {
  const navigate = useNavigate();
  const windowSize$ = useSharedState();

  const [reportsList, setReportsList] = useState({
    tableData: {
      headerContent: [],
      bodyContent: [],
    },
  });

  const [openDelete, setOpenDelete] = useState(false);
  const [record, setRecord] = useState({});

  useEffect(() => {
    listReportsTable();
  }, []);


  const listReportsTable = () => {
    ServiceUtils.getRequest("reportsTable").then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          let tableData = JSON.parse(JSON.stringify(response.data?.data));
          tableData?.headerContent?.map((el) => {
            if (el.key === "action") {
              el.render = (_, record) => (
                <Dropdown overlay={menu(record)} trigger={["click"]}>
                  <Button type="link" icon={<MoreOutlined />} />
                </Dropdown>
              );
            }
          });
          setReportsList(tableData);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

  const menu = (record) => (
    <Menu>
      <Menu.Item key="edit" onClick={() => handleTableActions(record, "edit")}>
        Edit
      </Menu.Item>
      <Menu.Item key="edit" style={{ color: "red" }} onClick={() => handleTableActions(record, "delete")}>
        Delete
      </Menu.Item>
    </Menu>
  );

  const handleTableActions = (data, action) => {
    if (action === "edit") {
      navigate(`/admin/reportSettings/${data?.id}`);
    } else if (action === "delete") {
      // deleteRecords(data)
      setRecord(data);
      setOpenDelete(true);
    }
  };

  const deleteRecords = () => {
    console.log('delete records:',record)
    let payload = {
      id: record?.id
    };
    ServiceUtils.deleteRequest("deleteReports",payload).then(
      (response) => {
        if (response.status === 200 && response?.data.status) {
          alertService.success(response.data.message);
          setOpenDelete(false);
          listReportsTable();
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  }
  return (
    <>
      <Card
        style={{ width: "100%", height: "fit-content" }}
        bodyStyle={{ padding: "10px" }}
      >
        <BreadcrumbList active={[{ label: "Reports Settings", link: "" }]} />
      </Card>
      <div className="reports-settings">
        <div>
          <Content
            style={{
              padding: "12px",
              background: "#fff",
              height: "calc(100vh - 90px)",
            }}
          >
            <Row style={{ width: "100%", margin: "5px" }}>
              <Col
                xs={{ flex: "100%" }}
                sm={{ flex: "100%" }}
                md={{ flex: "100%" }}
                lg={{ flex: "50%" }}
                xl={{ flex: "50%" }}
              >
                <div
                  className={classNames("", {
                    "search-kol-mobile":
                      windowSize$ === "lg" ||
                      windowSize$ === "xl" ||
                      windowSize$ === "xxl",
                    "search-kol-mobile":
                      windowSize$ === "xs" ||
                      windowSize$ === "sm" ||
                      windowSize$ === "md",
                  })}
                >
                  <div></div>
                </div>
              </Col>
              <Col
                xs={{ flex: "100%" }}
                sm={{ flex: "100%" }}
                md={{ flex: "100%" }}
                lg={{ flex: "50%" }}
                xl={{ flex: "50%" }}
              >
                <div
                  className={classNames("", {
                    "search-kol-mobile":
                      windowSize$ === "lg" ||
                      windowSize$ === "xl" ||
                      windowSize$ === "xxl",
                    "search-kol-mobile":
                      windowSize$ === "xs" ||
                      windowSize$ === "sm" ||
                      windowSize$ === "md",
                  })}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      margin: "3px",
                    }}
                  >
                    <Button
                      type="primary"
                      onClick={() => navigate(`/admin/reportSettings/add`)}
                    >
                      Add Reports
                    </Button>
                  </div>
                </div>
              </Col>
            </Row>
            <div
              className={classNames("", {
                "reports-container":
                  windowSize$ === "lg" ||
                  windowSize$ === "xl" ||
                  windowSize$ === "xxl",
                "reports-container-small":
                  windowSize$ === "xs" ||
                  windowSize$ === "sm" ||
                  windowSize$ === "md",
              })}
            >
              <Table
                columns={reportsList?.headerContent}
                dataSource={reportsList?.bodyContent}
                scroll={{ x: true, y: 400 }}
                pagination={false}
                bordered
              />
            </div>
          </Content>
        </div>
      </div>
      <Modal
        open={openDelete}
        onOk={deleteRecords}
        onCancel={() => setOpenDelete(false)}
      >
        Are you sure you want to delete the report?.
      </Modal>
    </>
  );
};

export default ReportsSettings;
